module.exports = __webpack_public_path__ + "img/logo.a96e8ad0.svg";